import { ICON_BY_CATEGORY } from "@app/analytics/components/Icons";

export const TOOLTIPS: { [key: string]: string } = {
  actionItems:
    "Action items are aggregated from all meeting reports that were generated during the selected time period",
  keyQuestions:
    "Key questions are aggregated from all meeting reports that were generated during the selected time period",
};

export const DETAILS_BY_TYPE = {
  action_items: {
    id: "actionItems",
    label: "action items",
    icon: ICON_BY_CATEGORY.action_items.Icon,
    emptyBlurb:
      "As you have more meetings, more action items will appear. For now, enjoy the emptiness.",
  },
  key_questions: {
    id: "keyQuestions",
    label: "key questions",
    icon: ICON_BY_CATEGORY.key_questions.Icon,
    emptyBlurb:
      "It's pretty quiet here. Have you had a meeting with Read recently?",
  },
};
